import { useCallback } from "react";
import { useQuery } from "hooks/useQuery";
import { getPortfolioTradingConnectionHpChart } from "../service";
import {
  getHpFilteredDataWithTimeframe,
  getHpLineColors,
} from "features/Strategy/utils";

export const useStrategyChartData = (tradingConnectionId) => {
  const fetchChartData = useCallback(async () => {
    const hpChart = await getPortfolioTradingConnectionHpChart(
      tradingConnectionId
    );

    const filterData = getHpFilteredDataWithTimeframe(hpChart);

    const lastIdx = Object.keys(filterData).length - 1;
    const defaultFilter = Object.keys(filterData)[lastIdx] || "";
    const lineColors = getHpLineColors(filterData[defaultFilter] || []);

    return {
      lines: lineColors,
      data: filterData,
      defaultFilter,
    };
  }, [tradingConnectionId]);

  const { isLoading, data } = useQuery({
    queryKey: ["strategyChart", "performance", tradingConnectionId],
    queryFn: fetchChartData,
    enabled: Boolean(tradingConnectionId),
  });

  return {
    isLoading,
    chartData: data || { lines: [], data: {}, defaultFilter: "" },
    defaultFilter: data?.defaultFilter || "",
  };
};
